import { render, staticRenderFns } from "./RuleReward.vue?vue&type=template&id=bd9c7770&scoped=true&"
import script from "./RuleReward.vue?vue&type=script&lang=js&"
export * from "./RuleReward.vue?vue&type=script&lang=js&"
import style0 from "./RuleReward.vue?vue&type=style&index=0&id=bd9c7770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9c7770",
  null
  
)

export default component.exports